/** @module csi/widget/_svg/ModeSelect */
define([
	"dijit/form/ToggleButton",
	"./_Plugin",
	"./PluginFactory"
], function(ToggleButton, _Plugin, PluginFactory) {

	return PluginFactory.declare([ToggleButton, _Plugin], {
		"class": "csi-button-toggle csi-toggle-group-first",
		iconClass: "fas fa-xs fa-mouse-pointer",
		pluginName: "SELECT",
		title: "CanvasSelect",

		/**
		 * Enable and disable the select mode
		 * @param {Shape[]} shapes
		 * @param {Object} shapeAttrs
		 * @param {Object} textAttrs
		 * @return {boolean}
		 */
		enablePlugin: function(shapes, shapeAttrs, textAttrs) {
			const {editor} = this;
			this.set("checked", editor.isEditTextCanvasMode() || editor.isSelectCanvasMode());
			return true;
		},

		/**
		 * Invoke set canvas mode action from c8-canvas library
		 */
		onClick: function() {
			this.editor.canvasApp.canvasApi().setCanvasMode(this.pluginName);
			this.set('checked', true);
		}
	});
});
